import type * as api from '@gitbook/api-client';
import { Icon } from '@gitbook/spine-icons';
import { Button, toast } from '@gitbook/spine-react';

import { apiClient } from '../../state';

/**
 * Actions when change request has been archived.
 */
export function ChangeRequestUnarchiveButton(props: {
    space: api.Space;
    changeRequest: api.ChangeRequest;
}) {
    const { space, changeRequest } = props;

    /** User confirmed that the change request should be unarchived */
    const onCompleteUnarchive = async () => {
        await toast.catch(async () => {
            await apiClient.changeRequests.updateChangeRequestById(space.id, changeRequest.id, {
                status: 'open',
            });

            toast.success('Change request unarchived', {
                description: 'This change request has now been reopened.',
            });
        }, 'Error while unarchiving change request');
    };

    return (
        <Button
            kind="secondary"
            size="medium"
            leadingIcon={Icon.ChangeRequest}
            onPress={onCompleteUnarchive}
            label="Unarchive"
        />
    );
}
